import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'IrisBreadCrumbsLazy',
        path: () => path.join(__dirname, './GalleryBreadCrumbs'),
        resolve: () => require.resolveWeak('./GalleryBreadCrumbs'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "IrisBreadCrumbsLazy" */ './GalleryBreadCrumbs'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
